import React, { useEffect, useState } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { getHistoryListService, messageActionService } from '../services/chatService';
import { normalFormateDateTime } from '../lib/helper';
import { formatAMPM, formatChatDate, messageActionOption, paginationLimit, paginationStartFrom, signUpType } from "../data/constants";
import deleteB from '../Asset/image/delete.png';
import shareB from '../Asset/image/share.png';
import CustomImage from "./CustomImage";
import { RWebShare } from "react-web-share";
import Pagination from 'react-bootstrap/Pagination';
import ReactPagination from "./ReactPagintion";
import { useAuth } from "../Context/AuthProvider";
import Loader from "./Loader";
let page = paginationStartFrom;
function HistoryModal({ show, setShow, historyData, getList, updateList, totalData, page, setPage }) {
    const { user } = useAuth()
    const handleClose = () => setShow(false);

    const getDate = (date) => {
        return normalFormateDateTime(date);
    };
    const renderLoader = () => {
        return (
            <Loader
                visible={false}
                emptyTextKey={'EmptyHistory'}
                style={{ top: 0, position: "relative", color: "white" }} />
        )
    }
    const handleNextClick = (data) => {
        // let Page = data.selected;
        if (user?.signuptype !== signUpType?.guest) {
            setPage(page + 1);
            getList();
        }
    }
    const handlePreviousClick = (data) => {
        // let Page = data.selected;
        if (page > 1)
            setPage(page - 1);
        getList();
    }
    const deleteHistory = async (item) => {
        try {
            const params = { messageid: item.message_id };
            const response = await messageActionService(
                params,
                messageActionOption.unSave,
            );
            toast.success(response?.data);
            if (response?.data) {
                updateList(item);
                getList();
            }
        } catch (error) {
            // showToast(error?.response?.data?.data);
            console.log(error);
        }
    };
    return (
        <>
            <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header className=" border-0 " closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">History</Modal.Title>
                </Modal.Header>

                <Modal.Body className="modalBody border-0">
                    <div className="sidemenu_scroll  sidespacing_scroll">
                        {!historyData.length ? renderLoader() : historyData.map((item, index) => {
                            return (
                                <Container className="modalGroup mt-2" key={index}>

                                    <Row>
                                        <Col md={8}>
                                            <p className='text-label'>{item.categoryname}</p>
                                            <p className='commentText  '>
                                                {item.text}
                                            </p>
                                        </Col>
                                        <Col md={4}>
                                            <div className="d-flex justify-content-end">
                                                <p className='sub-header2'>
                                                    {new Date(item.createdAt).getDate() === new Date().getDate() ? "Today" + "  " + formatAMPM(item.createdAt) : formatChatDate(new Date(item.createdAt)) + "  " + formatAMPM(item.createdAt)}
                                                </p>
                                                <CustomImage className="message_icon" onClick={() => deleteHistory(item)} src={deleteB} />
                                                <RWebShare
                                                    data={{
                                                        text: "Share Tamara chat",
                                                        url: "https://tamara.tech",
                                                        title: "Tamara Chat",
                                                    }}
                                                // onClick={() => console.log("shared successfully!")}
                                                >
                                                    <CustomImage className="message_icon" src={shareB} />
                                                </RWebShare>

                                            </div>

                                        </Col>
                                    </Row>

                                </Container>
                            )
                        })}

                    </div>
                </Modal.Body>

                <Modal.Footer className="footer_setting border-0" style={{ justifyContent: "center" }}>
                    <Button className="reset_button" disabled={page == 1 ? true : false} onClick={handlePreviousClick}>
                        Previous
                    </Button>
                    <p className='mt-1 d-none d-lg-block'>Total Records :{totalData}</p>
                    <Button className='submit_button' onClick={handleNextClick}>
                        Next
                    </Button>

                </Modal.Footer>
                <p className='mt-1 d-flex justify-content-center d-block d-lg-none'>Total Records :{totalData}</p>
            </Modal>
        </>
    );
}

export default HistoryModal;